/* eslint-disable no-shadow */

import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'
import { Container } from '@material-ui/core'
import styles from './View.Style'
import { FIRST_LIMIT_CONSTANT, LIMIT_CONSTANT } from 'common_constants/Ideas'
import IdeaPanel from 'components_newui/idea_panel/View'
import Breadcrumbs from 'components_newui/pageBreadcrumbsMenu/View'
import FilterComponent from 'components/filter_component/View'
import NxtCircularLoader from 'components/nxt_circular_loader/View'
import noDraftIdeasImg from '../../img/no_draft_idea.png'
import Navigation from 'support/navigation'
import i18n from 'support/i18n'
import * as pages from 'common_constants/Pages'
import NavigationService from 'support/navigation/NavigationService'
import InnovateAllIdeas from './InnovateAllIdeas'

const description = 'See what others have proposed!'

const pageHierarchy = [
  { string: 'Home', navigate: () => Navigation.navigateToExplore() },
  { string: 'All Ideas', navigate: () => {} },
]

/**
 * All Ideas page.
 *  - Innovate (hackathon) mode: <InnovateAllIdeas /> (ideaList endpoint, status / date / search filters).
 *  - Otherwise: the legacy idea list driven by FilterComponent + applyFilter (unchanged behaviour).
 */
const AllIdeas = (props) => {
  const {
    isAdmin,
    classes,
    domainLoaded,
    ideas,
    isIdeasLoading,
    itemsIdeas,
    ideasInvested,
    totalIdeas,
    serviceLineOrgs,
    typesStatus,
    ideaStatusStepper,
    useHelpSection,
    getUserOrganisations,
    getActiveOrganization,
    getActiveTypes,
    getHeaderSection,
    getHelpSection,
    applyFilter,
    applySearch,
    isHackathonEnable,
    fetchInnovateIdeaList,
  } = props

  const allInvestedIdeasPath = NavigationService.getRoutes()[pages.MY_INVESTED_IDEAS].path

  // ----- Legacy (non-hackathon) list state -----
  const [searchQuery, setSearchQuery] = useState('')
  const [offset, setOffset] = useState(0)
  const [activeFilters, setActiveFilters] = useState({
    ideaStatusFilter: [],
    challenge: {},
    organizationsFilter: [],
    types: [],
  })

  useEffect(() => {
    if (!isHackathonEnable && useHelpSection) {
      getHeaderSection()
      getHelpSection()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [useHelpSection, isHackathonEnable])

  useEffect(() => {
    if (!isHackathonEnable && domainLoaded) {
      getUserOrganisations()
      getActiveOrganization()
      getActiveTypes()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [domainLoaded, isHackathonEnable])

  const getIdeas = (offset = 0) => {
    const { ideaStatusFilter, challenge, types, organizationsFilter, ideasLocation } = activeFilters
    const serviceLineOrgsNameList = serviceLineOrgs
      .filter((item) => organizationsFilter.includes(item.id))
      .map((item) => item.name)

    applyFilter(
      challenge.id || '',
      serviceLineOrgsNameList,
      ideaStatusFilter,
      types,
      ideasLocation,
      offset ? LIMIT_CONSTANT : FIRST_LIMIT_CONSTANT,
      offset,
    )
  }

  const handleActiveFilters = (newFilters) => {
    setActiveFilters(newFilters)
    setOffset(0)
  }

  useEffect(() => {
    if (!isHackathonEnable) getIdeas()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilters, isHackathonEnable])

  const handleOnLoadMore = () => {
    const newOffset = (offset ? LIMIT_CONSTANT : FIRST_LIMIT_CONSTANT) + offset
    getIdeas(newOffset)
    setOffset(newOffset)
  }

  return (
    <>
      <Breadcrumbs crumbs={pageHierarchy} />
      <Container>
        {isHackathonEnable ? (
          <InnovateAllIdeas classes={classes} isAdmin={isAdmin} fetchInnovateIdeaList={fetchInnovateIdeaList} />
        ) : (
          <main className={classes.background}>
            <div className={classes.content_container}>
              <div className={classes.top_section_text}>
                <p className={classes.title}>All ideas</p>
                <Link to={`${allInvestedIdeasPath}`} className={classes.invested_ideas_number}>
                  My invested ideas ({ideasInvested.length})
                </Link>
              </div>
            </div>

            <p className={classes.lower_title}>All Ideas ({totalIdeas})</p>
            <p className={classes.lower_description}>{description}</p>

            <FilterComponent
              activeFilters={activeFilters}
              serviceLineOrgs={serviceLineOrgs}
              types={typesStatus}
              ideaStatusFilter={ideaStatusStepper}
              handleActiveFilters={handleActiveFilters}
              search={searchQuery}
              setSearch={setSearchQuery}
              applySearch={applySearch}
              resetSearch={getIdeas}
            />

            <NxtCircularLoader isLoading={isIdeasLoading}>
              <div className={classes.content_container}>
                {ideas.length > 0 ? (
                  <div className={classes.IdeaGrid}>
                    {ideas.map((idea) => <IdeaPanel key={idea.id} urlId={idea.id} idea={idea} />)}
                  </div>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                    <img src={noDraftIdeasImg} className={classes.no_idea_img} alt="no idea found" />
                    <div className={classes.no_idea_title}>No ideas found</div>
                  </div>
                )}
              </div>

              {itemsIdeas >= 11 ? (
                <div className={classes.loadMoreWrapper}>
                  <button type="button" className={classes.loadmorebtn} onClick={handleOnLoadMore}>
                    {i18n.t('HOME.FILTER.LOAD_MORE')}
                  </button>
                </div>
              ) : null}
            </NxtCircularLoader>
          </main>
        )}
      </Container>
    </>
  )
}

export default withStyles(styles)(AllIdeas)